import { Grid, Card, CardContent, Button, Typography, Icon } from '@mui/material'

import { TrendingDown } from 'react-feather'
import { useFechInitVehicleApplies } from './hooks';
import { useLocation, useParams } from 'react-router-dom';
import { AllowedAccess } from 'react-permission-role';
import { CreditsForm } from './CreditsForm/CreditsForm';
import { LogBook } from './Logbook/LogBook';
import { Expenses } from './Expenses/Expenses';
import { UncollectibleCreditsTable } from './CreditsTable/UncollectibleCreditsTable';

export const UncollectibleCredits = () => {

  const location = useLocation();
  const paramsURL = useParams();
  const useFetchInit = useFechInitVehicleApplies({ location, paramsURL })

  const {
    globalStates,
  } = useFetchInit

  const { showForm, showLogBook, showExpenses } = globalStates


  return (
    // <VehicleAppliesProvider >
    <AllowedAccess permissions={['236_CREDITOS_INCOBRABLES']} renderAuthFailed={<p>Error</p>}>
      <div className='content'>
        {!(showForm || showLogBook || showExpenses) && (
          <div className='panel-body' id='listadoregistros'>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Card>
                  <CardContent >
                    <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mt: 1, mb: 3 }}>

                      <Typography variant='h4' sx={{ display: 'flex', alignItems: 'center' }}>
                        Creditos Incobrables
                        <Icon component={TrendingDown} sx={{ ml: 1, fontSize: '1.5rem' }} />
                      </Typography>

                    </Grid>
                    <div className="pt-4"></div>

                    <UncollectibleCreditsTable
                      useFetchInit={useFetchInit}
                    />
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </div>
        )}
        {(showForm) && (
          <>
            <div className='panel-body' id='formularioregistros'>
              <CreditsForm
                useFetchInit={useFetchInit}
              />
            </div>
          </>
        )}
        {(showLogBook) && (
          <>
            <div className='panel-body' style={{ height: '100%', overflow: 'hidden' }} >
              <LogBook
                useFetchInit={useFetchInit}
              />
            </div>
          </>
        )}
        {(showExpenses) && (
          <>
            <div className='panel-body' style={{ height: '100%', overflow: 'hidden' }} >
              <Expenses
                useFetchInit={useFetchInit}
              />
            </div>
          </>
        )}
      </div>
    </AllowedAccess>

  )
}
